import angular from 'angular';
import template from './template.html';

export class TFTOptionList {
    optionClick(option, event) {
        event.stopPropagation();

        this.onOptionClick({ option });
    }
}

export const TFTOptionListConfiguration = {
    template,
    controller: TFTOptionList,
    bindings: {
        options: '<',
        onOptionClick: '&',
        testId: '@',
    },
    controllerAs: 'optionListCtrl',
};

angular.module('TALENYA-FE').component('tftOptionList', TFTOptionListConfiguration);
